import React, { useState } from "react";
import { Card, StatusPill } from "../ui-bj/Primitives";
import { ChargeCardModal } from "./ChargeCardModal";
import { printInvoicePDF } from "../../lib/invoicePdf";
import { PRODUCTS } from "../../config/products";

const PRODUCT_NAME = Object.fromEntries(PRODUCTS.map((p) => [p.key, p.name]));

const money = (cents) => `$${((cents || 0) / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const InvoiceList = ({ invoices, onRefresh }) => {
  const [chargingInvoice, setChargingInvoice] = useState(null);

  return (
    <Card data-testid="billing-invoices-list" className="overflow-x-auto">
      <table className="w-full min-w-[1000px]">
        <thead>
          <tr className="text-left">
            {["Number","Client","Product","Total","Balance","Status","Created","Action"].map((h) => (
              <th key={h} className="bj-table-header py-2 pr-3 whitespace-nowrap">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {invoices.length === 0 && <tr><td colSpan={8} className="py-10 text-center text-[#5E4D40] text-sm">No invoices generated yet.</td></tr>}
          {invoices.map((inv, i) => {
            const isOverdue = inv.totals.status === "Overdue";
            const canCharge = (inv.totals.balance_cents || 0) > 0 && !inv.voided;
            return (
              <tr key={inv._id} data-testid={`invoice-row-${i}`} className="bj-table-row">
                <td className="py-3 pr-3 text-[#6E5022] text-sm bj-tnum">{inv.number}</td>
                <td className="py-3 pr-3 text-[#2A1C15] text-sm">{inv.client_name}</td>
                <td className="py-3 pr-3 text-[#5E4D40] text-xs">{Array.from(new Set(inv.lines.map((l) => PRODUCT_NAME[l.product_key] || l.product_key))).join(", ")}</td>
                <td className="py-3 pr-3 text-[#2A1C15] text-sm bj-tnum">{money(inv.totals.total_cents)}</td>
                <td className={`py-3 pr-3 text-sm bj-tnum ${isOverdue ? "text-[#5C1A24] font-heading" : "text-[#2A1C15]"}`}>{money(inv.totals.balance_cents)}</td>
                <td className="py-3 pr-3"><StatusPill status={inv.totals.status} /></td>
                <td className="py-3 pr-3 text-[#5E4D40] text-xs bj-tnum">{new Date(inv.created_at).toLocaleDateString()}</td>
                <td className="py-3 pr-3">
                  <div className="flex items-center gap-2">
                  <button
                    data-testid={`invoice-pdf-${i}`}
                    onClick={() => printInvoicePDF(inv)}
                    className="pr-btn-outline"
                  >
                    PDF
                  </button>
                  {canCharge ? (
                    <button
                      data-testid={`invoice-charge-${i}`}
                      onClick={() => setChargingInvoice(inv)}
                      className="pr-btn pr-btn-sm"
                    >
                      Charge
                    </button>
                  ) : (
                    null
                  )}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {chargingInvoice && (
        <ChargeCardModal
          invoice={chargingInvoice}
          onClose={() => setChargingInvoice(null)}
          onSuccess={() => {
            setChargingInvoice(null);
            onRefresh?.();
          }}
        />
      )}
    </Card>
  );
};
